import axiosClient from 'utils/axiosClient';
import api from 'api';

const getRooms = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY.ROOMS.ROOMS, {params: data});
	return response.data;
};

const getRoomByID = async (id: any, data?: any) => {
	const response = await axiosClient.get(api.LIBRARY.ROOMS.ROOMS_BY_ID + id, data);
	return response.data;
};

const createRoom = async (data: any) => {
	const response = await axiosClient.post(api.LIBRARY.ROOMS.ROOMS, data);
	return response.data;
};

const updateRoom = async (id: number, data: any) => {
	const response = await axiosClient.patch(api.LIBRARY.ROOMS.ROOMS_BY_ID + id, data);
	return response.data;
};

const deleteRooms = async (ids: number) => {
	const response = await axiosClient.delete(api.LIBRARY.ROOMS.ROOMS_BY_IDS + ids);
	return response.data;
};

const checkBookingTimes = async (id: any, data?: any) => {
	const response = await axiosClient.get(
		api.LIBRARY.ROOMS.ROOM_AVAILABILITY_BY_ID + id + '/availability',
		data
	);
	return response.data;
};

const service = {
	getRooms,
	getRoomByID,
	createRoom,
	updateRoom,
	deleteRooms,
	checkBookingTimes
};

export default service;
